import { Amount as AmountDto, ReservationLinkResult } from '@mews-commander/data-access';

export enum CreatePaymentPlanFormField {
    PlanName = 'planName',
    ReservationId = 'reservationId',
    BillingMode = 'billingMode',
    PaymentPlanIntervalKind = 'paymentPlanIntervalKind',
    StartDateUtc = 'startDateUtc',
    PaymentMethods = 'paymentMethods',
    Amount = 'amount',
    Reason = 'reason',
    Message = 'message',
    Note = 'note',
}

export enum PaymentPlanIntervalKind {
    Reservation = 'reservation',
    Custom = 'custom',
}

export interface MonthlyPaymentPlanAmount {
    monthName: string;
    amount: AmountDto;
    monthIndex: string;
}

export interface ReservationForCreatePaymentPlan extends ReservationLinkResult {
    isValid: boolean;
}

export type CreatePaymentPlanFormStep = 'planDetails' | 'firstPayment' | 'summary';
